import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/jeff-avatar.webp")